module.exports = __webpack_public_path__ + "img/adModel2.fb902b2e.png";